import { RETRY_FETCH_ACCOUNTS } from './actionTypes';

const retryFetchAccounts = () => ({ type: RETRY_FETCH_ACCOUNTS });

export default retryFetchAccounts;
